module.exports = __webpack_public_path__ + "static/media/person2.62a1c506.png";